import React from 'react';

import CreateProjectComponent from 'components/Projects/CreateProject';

const CreateProject: React.FC = () => <CreateProjectComponent />;

export default CreateProject;
